export default __webpack_public_path__ + "static/media/logo-app2.45eb3591.svg";